import type {Pointer, Pointers} from '@wix/document-services-types'
import {VIEW_MODES} from '../../../constants/constants'

export class WidgetRepository {
    constructor(private readonly pointers: Pointers) {}

    getWidgetPagePointer(widgetPageId: string): Pointer {
        return this.pointers.structure.getPage(widgetPageId, VIEW_MODES.DESKTOP)
    }

    /**
     * Gets all child pointers recursively from a widget root pointer
     * @param widgetRootPointer The root pointer of the widget (must be of type AppWidget)
     * @returns Array of all descendant pointers
     */
    getAllChildrenPointers(widgetRootPointer: Pointer): Pointer[] {
        return this.pointers.structure.getChildrenRecursively(widgetRootPointer)
    }

    /**
     * Gets the root container pointer from a widget's root pointer
     * @param widgetRootPointer The root pointer of the widget (must be of type AppWidget)
     * @returns The first child pointer (root container) or null if no children exist
     */
    getRootContainerPointerFromRootWidget(widgetRootPointer: Pointer): Pointer | null {
        const [firstChild] = this.pointers.structure.getChildren(widgetRootPointer)
        return firstChild || null
    }
}
